import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=3d43127a&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d43127a')) {
      api.createRecord('3d43127a', component.options)
    } else {
      api.reload('3d43127a', component.options)
    }
    module.hot.accept("./notes.vue?vue&type=template&id=3d43127a&", function () {
      api.rerender('3d43127a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/subcomponents/notes.vue"
export default component.exports